import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import searchService from '../services/searchService';

export default function BrandsFilter({ brands, onFilter, selectedMaker }) {
  const styleFilterBadge = {
    margin: 0,
    background: 'gray',
    fontSize: '12px',
    color: 'white',
    borderRadius: 100,
    display: 'inline-block',
    padding: '3px 6px 1px 6px',
    marginTop: '3px',
    marginLeft: '5px'
  }

  const styleButton = {
    textAlign: 'left',
    padding: '10px 0px 10px 0px',
  }

  const handleBrandClick = async (brand) => {
    if (!onFilter) return;
    try {
      const filters = { maker: brand.name, page: 0, size: 5 };
      const results = await searchService.searchVehicles(filters);
      onFilter({
        results: results.content,
        totalElements: results.totalElements,
        totalPages: results.totalPages,
        currentPage: results.number + 1,
        filters,
      });
    } catch (error) {
      console.error('Error al filtrar por marca:', error);
    }
  };

return (
  <>
    <h5>Marcas</h5>
    <div
      style={{
        width: '100%',
        maxHeight: '300px',
        overflowY: 'auto',
        scrollBehavior: 'smooth',
      }}
      className="shadow p-2 mb-5 bg-white card-navigation-menu custom-scroll"
    >
      <ButtonGroup vertical style={{ width: '100%' }}>
        {brands.filter(item => (item.count ?? 0) >= 1).map((item, key) => (
          <Button
            variant={selectedMaker === item.name ? 'primary' : 'outline-primary'}
            style={styleButton}
            key={key}
            onClick={() => handleBrandClick(item)}
          >
            <div>{item.name}</div>
            <div style={styleFilterBadge}>{item.count ?? 0} Autos</div>
          </Button>
        ))}
      </ButtonGroup>
    </div>
  </>
);
};